import { HttpClient } from '@angular/common/http';
import { CacheService } from '../cache';
import { ResourceService } from './resource';
import { User, IUser, OnboardBusinessPayload,Address,OnboardResponse} from '../../models/user';
import { Injectable } from '@angular/core';
import { Observable, observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})


export class SetupService extends ResourceService<User> {
 /**
    * @constructor
    * Creates an instance of the SetupService
    *
    * @param {HttpClient} http Injected instance of HttpClient
    * @param {CacheService} cache Injected instance of CacheService
  */
  constructor(
    protected http: HttpClient,
    protected cache: CacheService
  ) {
    super(http, cache, 'setup');
  }

   /**
    * Sends a POST request to the /setup/send-verification-email endpoint
    * @remarks
    * to send verification email after registration
    *
    * @returns {Observable} Returns an observable
  */
  sendVerificationEmail() {
    return this.http.post(`${this.endpoint}/send-verification-email`, {})
  }


  /**
    * Sends a POST request to the /setup/verify-email endpoint
    * @remarks
    * to verify email after registration
    *
    * @param {string} code Verification code passed as body to the server
    * @returns {Observable} Returns an observable
  */
  verifyEmail(code: string) {
    return this.http.post(`${this.endpoint}/verify-email`, { code })
  }

  addPhone(phone: string) {
    return this.http.post(`${this.endpoint}/add-phone`, { phone })
  }

   /**
    * Sends a POST request to the /setup/verify-phone endpoint
    * @remarks
    * to verify phone number
    *
    * @param {code: string, phone: string} data body of request made to the server
    * @returns {Observable} Returns an observable
  */
  verifyPhone(data: {code: string, phone: string}) {
    return this.http.post(`${this.endpoint}/verify-phone`, data)
  }
  // ──────────────────────────────────────────────
  //  New method for business onboarding
  // ──────────────────────────────────────────────
  onboardBusiness(payload: OnboardBusinessPayload): Observable<OnboardResponse> {

    return this.http.post<OnboardResponse>(`${this.endpoint}/onboard`, payload);
  }

  /**
   * Sends a POST request to the /setup/accept-invitation endpoint
   * @remarks
   * to accept employee invitation
   *
   * @param {any} payload Invitation acceptance payload
   * @returns {Observable} Returns an observable
   */
  acceptInvitation(payload: any) {
    return this.http.post(`${this.endpoint}/accept-invitation`, payload);
  }
}
